import React from 'react'
import styled from 'styled-components'
import ButtonTC from '../../../../components/button-tc/button-tc'
import { Location } from '@styled-icons/evil'
import { Calendar } from '@styled-icons/feather'
import { ArrowSwap } from '@styled-icons/fluentui-system-filled'
import { device } from '../../../../config/theme/breakpoints'
import CalendarTC from '../../../../components/calendar-tc/calendar-tc'
import SelectTC from '../../../../components/select-tc/select-tc'

const FormContainer = styled.div<{ auto: boolean }>`
  width: 80%;
  margin: auto;
  background: white;
  border-radius: 50px 10px 50px 10px;
  padding: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${p => p.theme.palette.text.primary};
  margin-bottom: ${p => p.auto ? '30px' : '0'};
  flex-direction: column;
  position: relative;
  z-index: 4;

  @media ${device.tablet}{
    flex-direction: row;
  }
`
const ItemSearchContainer = styled.div`
  width: 100%;
  height: inherit;
  gap: 10px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: left;
  padding: 8px 5px 8px 20px;
  border-bottom: 1px solid #a6a6a6;
  border-right: none;
  cursor: text;

  > svg{
    width: 18px;
    color: ${p => p.theme.palette.icon.primary};
  }

  > p{
    color: ${p => p.theme.palette.text.black};
    font-size: 12px;
    font-weight: 100;
  }

  :nth-child(1){
    border-radius: 60px 0 0 10px;
    border-left: 1px solid white;
  }

  :nth-child(5){
    border-radius: 0 10px 60px 0;
    border-right: none;
    border-bottom: none;
    cursor: auto;
  }

  @media ${device.tablet}{
    border-right: 1px solid #a6a6a6;
    border-bottom: none;
  }
`
const Divider = styled.div`
  width: fit-content;
  height: fit-content;
  position: absolute;
  background: white;
  margin: auto;
  top: 100%;
  right: 0;
  bottom: 0;
  left: 0;

  > div {
    border: 1px solid #a6a6a6;
    border-radius: 50%;
    padding: 2px;

    svg{
      width: 20px;
      color: ${p => p.theme.palette.icon.secondary}; 
    }
  }

  @media ${device.tablet}{
    top: 0;
    right: -14px;
    bottom: 0;
    left: calc(100% - 14px);
  }
`
const customStyledButton = `
  border-radius: 30px 4px 30px 4px;
  width: 100%;
  margin-right: 10px;
  height: 40px;

  > div {
    justify-content: center;
  }
  > div div{
    margin: auto;
    font-weight: bold;
  }
`

const CustomInputText = `
  height: inherit;
`

const customSelect = `
  height: auto;

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  select::-ms-expand {
    display: none;
  }
`
interface IOwnProps {
  auto?: boolean
}

const FormSearchTour: React.FunctionComponent<IOwnProps> = ({ auto = false }) => {
  const inputOrigenRef = React.useRef<HTMLInputElement>(null)
  const inputDestinoRef = React.useRef<HTMLInputElement>(null)
  
  const handleInputOrigen = () => inputOrigenRef.current?.click()
  const handleInputDestino = () => inputDestinoRef.current?.click()

  return (
    <FormContainer auto={auto}>
      <ItemSearchContainer onClick={handleInputOrigen}>
        <SelectTC
          textHolder='Origen'
          background='white'
          icon={<Location />}
          className={customSelect}
          selectRef={inputOrigenRef}
          listOptions={['Trujillo', 'Lima','Trujillo', 'Lima','Trujillo', 'Lima','Trujillo', 'Lima','Trujillo', 'Lima','Trujillo', 'Lima','Trujillo', 'Lima','Trujillo', 'Lima','Trujillo', 'Lima', 'Trujillo', 'Lima', 'Trujillo', 'Lima']}
        />
        <Divider>
          <div><ArrowSwap /></div>
        </Divider>
      </ItemSearchContainer>
      <ItemSearchContainer onClick={handleInputDestino}>
        <SelectTC
          textHolder='Destino'
          background='white'
          icon={<Location />}
          className={customSelect}
          selectRef={inputDestinoRef}
          listOptions={['Trujillo', 'Lima']}
        />
      </ItemSearchContainer>
      <ItemSearchContainer>
        <CalendarTC
          icon={<Calendar />}
          textHolder='Ida'
          background='white'
          className={CustomInputText}
        />
      </ItemSearchContainer>
      <ItemSearchContainer>
        <CalendarTC
          icon={<Calendar />}
          textHolder='Regreso'
          background='white'
          className={CustomInputText}
        />
      </ItemSearchContainer>
      <ItemSearchContainer>
        <ButtonTC text="Buscar" className={customStyledButton} to='/proceso-venta'/>
      </ItemSearchContainer>
    </FormContainer>
  )
}

export default FormSearchTour